import { computed, defineComponent, ref, watch } from '@vue/composition-api';
import IconSpinner from '@/components/Icon/icons/IconSpinner.vue';
import { useRouteQuery } from '@/composables';
import { FILTER_DEBOUNCE } from '@/constants/filters';
import ObjectsTreeNode from './ObjectsTreeNode.vue';
import apiV2 from '@/api/v2';
import debounce from 'lodash.debounce';
export default defineComponent({
    name: 'ObjectsDrilldownView',
    components: {
        IconSpinner,
        ObjectsTreeNode,
    },
    setup(_, ctx) {
        const { routeQuery } = useRouteQuery(ctx);
        const brandId = computed(() => ctx.root.$route.params.id);
        const isLoadingTree = ref(false);
        const treeData = ref([]);
        const treeQuery = computed(() => {
            const query = routeQuery.value;
            const params = {
                brandId: brandId.value,
            };
            if (query.internalStatus) {
                params.internalStatus = query.internalStatus;
            }
            if (query.q) {
                params.q = query.q;
            }
            if (query.isImportant) {
                params.isImportant = query.isImportant;
            }
            if (query.tags && query.tags.length) {
                params.tags = query.tags;
            }
            if (query.objectTypeIds && query.objectTypeIds.length) {
                params.objectTypeIds = query.objectTypeIds;
            }
            if (query.centralCostId) {
                params.centralCostId = query.centralCostId;
            }
            return params;
        });
        const fetchTree = async () => {
            isLoadingTree.value = true;
            try {
                const { data } = await apiV2.get('/objects-tree', {
                    params: treeQuery.value,
                });
                treeData.value = data.data;
            }
            catch {
                treeData.value = [];
            }
            finally {
                isLoadingTree.value = false;
            }
        };
        const debouncedFetchTree = debounce(fetchTree, FILTER_DEBOUNCE);
        watch(treeQuery, () => {
            debouncedFetchTree();
        }, { immediate: true, deep: true });
        return {
            isLoadingTree,
            treeData,
        };
    },
});
